import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import * as ace from 'ace-builds';
import { Ace } from 'ace-builds';
import Editor = Ace.Editor;

@Component({
  selector: 'app-ace-editor',
  templateUrl: './ace-editor.component.html',
  styleUrls: ['./ace-editor.component.scss'],
  standalone: false
})
export class AceEditorComponent implements AfterViewInit {
  @ViewChild('editor') private _editor: ElementRef<HTMLElement>;

  _aceEditor: Editor;
  _readOnly: boolean = false;
  _theme: string = 'monokai';
  _mode: string = 'html';
  _text: string = '';
  _options: object = {};

  @Input() set readOnly(readOnly: boolean) {
    if (this._readOnly !== readOnly) {
      this._readOnly = readOnly;
      this.updateAceEditor();
    }
  }

  @Input() set theme(theme: string) {
    if (this._theme !== theme) {
      this._theme = theme;
      this.updateAceEditor();
    }
  }

  @Input() set mode(mode: string) {
    if (this._mode !== mode) {
      this._mode = mode;
      this.updateAceEditor();
    }
  }

  @Input() set text(text: string) {
    if (this._text !== text) {
      this._text = text;
      this.updateAceEditor();
    }
  }

  @Input() set options(options: object) {
    if (this._options !== options) {
      this._options = options;
      this.updateAceEditor();
    }
  }

  ngAfterViewInit(): void {
    this._aceEditor = ace.edit(this._editor.nativeElement);
    this.updateAceEditor();
  }

  private updateAceEditor(): void {
    if (this._aceEditor) {
      this._aceEditor.setOption('readOnly', this._readOnly);
      this._aceEditor.setOption('theme', `ace/theme/${this._theme}`);
      this._aceEditor.setOption('mode', `ace/mode/${this._mode}`);
      this._aceEditor.setOption('fontSize', '12px');
      this._aceEditor.setOptions(this._options);
      this._aceEditor.session.setValue(this._text);
    }
  }
}
